import axios from "axios";

import { BASE_URL, ROLES } from "../components/helpers/constants";
import {
  decryptPayload,
  getAccountArchivedMessage,
  getObjLength,
  handleExpiredSessionRedirect,
  isAccountArchivedApiResponse,
  isArrayBufferLike,
  parseArrayBufferToJson,
  shouldExpireSessionForApiStatus,
} from "../components/helpers/utils";

export const patchAPIPayload = async (data) => {
  const passingData = data.data === undefined ? {} : data.data;

  return await axios
    .patch(`${BASE_URL}${data.url}`, passingData, {
      timeout: 120000,
      headers: {
        authorization: data.token
          ? `Bearer ${localStorage.getItem("authToken")}`
          : null,
        "content-type": "application/json",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      const status = error.response?.status;
      const responseData = error?.response?.data;
      if (shouldExpireSessionForApiStatus(status, responseData)) {
        handleExpiredSessionRedirect(window.location.pathname, {
          accountArchived: isAccountArchivedApiResponse(responseData),
          message: isAccountArchivedApiResponse(responseData)
            ? getAccountArchivedMessage(responseData)
            : undefined,
          responseData,
        });
      }
      return {
        success: false,
        message: responseData?.message || error.message,
        data: responseData,
        statuscode: status,
      };
    });
};

export const postAPIPayload = async (data) => {
  console.log("payload", data);
  let passingData = data.data === undefined ? {} : data.data;
  let device = decryptPayload(localStorage.getItem("isMobile"));

  // to identify logged in devices
  if (
    decryptPayload(localStorage.getItem("roles"))?.includes(ROLES.customer) ||
    decryptPayload(localStorage.getItem("roles"))?.includes(
      ROLES.professional,
    ) ||
    decryptPayload(localStorage.getItem("path"))?.includes("create-account")
  ) {
    // for form data
    const formData = new FormData();
    if (device) {
      formData.append(`device_type`, device);
    } else {
      formData.append(`device_type`, "web");
    }

    if (!(data?.data instanceof FormData)) {
      if (device) {
        passingData = { ...passingData, device_type: device };
      } else {
        passingData = { ...passingData, device_type: "web" };
      }
    }
    // else {
    //   const formData = new FormData();
    //   formData.append(`document`, ...passingData);
    //   if (device) {
    //     formData.append(`device_type`, device);
    //   } else {
    //     formData.append(`device_type`, "web");
    //   }
    // }

    // when paylaod includes the form data but not uploading the file
    if (data?.data instanceof FormData) {
      for (const [key, value] of data?.data?.entries()) {
        formData.append(key, value);
      }
      passingData = formData;
    }
  } else if (
    data.url === "login" &&
    passingData &&
    !(passingData instanceof FormData)
  ) {
    passingData = { ...passingData, device_type: device || "web" };
  }

  return await postAPICall(
    data.url,
    passingData,
    data.token,
    data.isFile,
    data?.brokertoken,
    data?.responseType,
  );
};

export const postAPICall = async (
  url,
  reqbody,
  token,
  isFile = false,
  brokertoken,
  responseType,
) => {
  return await axios
    .post(`${BASE_URL}${url}`, reqbody, {
      timeout: 120000,
      headers: {
        authorization: token
          ? `Bearer ${localStorage.getItem("authToken")}`
          : brokertoken
            ? `Bearer ${localStorage.getItem("agentauthToken")}`
            : null,
        "content-type": isFile ? "multipart/form-data" : "application/json",
      },
      ...(responseType ? { responseType } : {}),
    })
    .then(function (response) {
      console.log("in postAPIPayload gettRequest...", response);
      return response.data;
    })
    .catch(function (error) {
      console.error("Error in postAPIPayload gettRequest", error);

      const rawErrorData = error?.response?.data;
      const parsedErrorData =
        responseType === "arraybuffer"
          ? (parseArrayBufferToJson(rawErrorData) ?? rawErrorData)
          : rawErrorData;

      if (
        responseType === "arraybuffer" &&
        parsedErrorData &&
        typeof parsedErrorData === "object" &&
        !isArrayBufferLike(parsedErrorData)
      ) {
        return {
          ...parsedErrorData,
          statuscode: error?.response?.status,
        };
      }

      let data = {
        success: false,
        error: error.message,
        message:
          error.code === "ECONNABORTED"
            ? "The request timed out. Your payment may still be processing — please check your properties before trying again."
            : error?.response?.data?.message || error.message,
        data:
          responseType === "arraybuffer"
            ? parsedErrorData
            : error?.response?.data,
        statuscode: error.response?.status,
      };
      const status = error.response?.status;
      const responseData = error.response?.data;
      if (shouldExpireSessionForApiStatus(status, responseData)) {
        handleExpiredSessionRedirect(window.location.pathname, {
          accountArchived: isAccountArchivedApiResponse(responseData),
          message: isAccountArchivedApiResponse(responseData)
            ? getAccountArchivedMessage(responseData)
            : undefined,
          responseData,
        });
      }
      return data;
    });
};
